import { Component, effect, signal } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { CustomUserAccountService } from 'src/app/services/user-account.service';
import { NavigationEnd, Router } from '@angular/router';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { NavMenuService } from '@custom-header/services/nav-menu.service';

@Component({
  selector: 'app-custom-cx-login',
  standalone: false,
  templateUrl: './custom-cx-login.component.html',
  styleUrls: ['./custom-cx-login.component.scss'],
})
export class CustomCxLoginComponent {
  isUserlogged$ = this.auth.isUserLoggedIn();
  user$ = this.userService.get();
  currentUnit$ = this.userService.getCurrentUnit();
  isBlue = signal(false);
  private readonly disabledRoutes = ['/checkout/billing-address', '/quoteEditPage', '/checkout/delivery-address'];

  logout() {
    return this.auth.logout();
  }

  async toggle() {
    this.navMenuService.toggle();
  }

  handleMyAccountClick() {
    if (this.isMyAccountDisabled()) {
      return;
    }
    this.toggle();
  }

  isMyAccountDisabled(): boolean {
    return this.disabledRoutes.some((route) => this.router.url.includes(route));
  }

  showMenu() {
    this.navMenuService.open();
  }

  hideMenu() {
    this.navMenuService.close();
  }

  handleMenuItemClick() {
    this.isBlue.set(false);
    this.hideMenu();
  }

  async handleItems(navMenu: HTMLElement) {
    return new Promise<void>((resolve) => {
      const menuItems = navMenu.getElementsByTagName('li');
      for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('click', () => {
          this.isBlue.set(false);
          resolve();
        }, { once: true });
      }
    });
  }

  isSmallScreen$ = this.breakPointService.isDown(BREAKPOINT.md);
  isMenuCollapsed = this.navMenuService.isMenuCollapsed;

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.navMenuService.close();
      }
    });
  }

  constructor(
    private auth: AuthService,
    private userService: CustomUserAccountService,
    private router: Router,
    private breakPointService: BreakpointService,
    private navMenuService: NavMenuService
  ) {
    effect(() => {
      this.isBlue.set(!this.navMenuService.isMenuCollapsed());
    });
  }
}